<template>
  <section class="new-folder">
    <v-btn
      class="new-button"
      @click.stop="newFolderForm = true"
      color="accent"
      round
      dark
      fixed
      bottom
      large
      right
    >
      <v-icon left>mdi-plus</v-icon>
      Novo Processo
    </v-btn>

    <v-navigation-drawer
      v-model="newFolderForm"
      :permanent="newFolderForm"
      temporary
      floating
      fixed
      right
      width="640"
    >
      <v-toolbar
        color="accent"
        flat
        dark
      >
        <v-icon>mdi-folder-plus mdi-24px</v-icon>
        <v-toolbar-title>Novo Processo</v-toolbar-title>
      </v-toolbar>

      <v-container>
        <v-form ref="form" v-if="!isCreating">
          <v-layout column>
            <v-flex>
              <v-subheader class="pa-0">
                Selecione o Tipo de Processo

                <span class="red--text">&nbsp;*</span>
              </v-subheader>

              <v-autocomplete
                v-model="formField.folderTypeSelected"
                :items="formField.folderTypeItems"
                :hide-no-data="!isEmpty(formField.folderTypeSelected)"
                :readonly="!isEmpty(formField.folderTypeSelected)"
                item-text="name"
                label="Digite o nome do tipo de processo"
                append-icon=""
                hide-selected
                open-on-clear
                clearable
                solo
                required
                return-object
                no-data-text="Tipo de processo não encontrado"
              >
                <template
                  slot="selection"
                  slot-scope="{ item, selected }"
                >
                  <v-list-tile-avatar width="24">
                    <v-icon class="amber--text mr-2">mdi-folder-open mdi-24px</v-icon>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title v-text="item.name"></v-list-tile-title>
                  </v-list-tile-content>
                </template>

                <template
                  slot="item"
                  slot-scope="{ item, tile }"
                >
                  <v-list-tile-avatar
                    class="headline font-weight-light white--text"
                    width="24"
                  >
                    <v-icon class="amber--text mr-2">mdi-folder-open mdi-24px</v-icon>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title v-text="item.name"></v-list-tile-title>
                  </v-list-tile-content>
                </template>

                <template slot="no-data">
                  <v-list-tile-content>
                    <v-list-tile-title class="px-3">
                      Nenhum tipo de processo encontrada com esse termo.
                    </v-list-tile-title>
                  </v-list-tile-content>
                </template>
              </v-autocomplete>
            </v-flex>

            <v-flex>
              <v-subheader class="pa-0">
                Descrição do processo
                <span class="red--text">&nbsp;*</span>
              </v-subheader>

              <v-layout row align-center>
                <v-flex md12>
                  <v-textarea
                    v-model="formField.subject"
                    label="Solo"
                    placeholder="Informe qual o assunto/motivo para abertura do processo"
                    counter="250"
                    maxlength="250"
                    solo
                    no-resize
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-flex>

            <v-flex>
              <v-subheader class="pa-0">
                Entidade
                <span class="red--text">&nbsp;*</span>
                <v-btn
                  v-if="!isEmpty(formField.folderEntitySelected)"
                  flat
                  small
                  color="accent"
                  @click.stop="resetFolderEntity()"
                >
                  Alterar
                </v-btn>
              </v-subheader>

              <v-layout row align-center>
                <v-flex md12>
                  <v-autocomplete
                    :loading="isFetchingEntities"
                    v-if="isEmpty(formField.folderEntitySelected)"
                    v-model="formField.folderEntitySelected"
                    :items="entitiesFound"
                    :hide-no-data="!entityQuery || isUserTyping"
                    no-filter
                    label="CPF/CNPJ ou nome da entidade"
                    item-text="name"
                    hide-selected
                    open-on-clear
                    clearable
                    required
                    return-object
                    :search-input.sync="entityQuery"
                    no-data-text="Entidade não encontrada!"
                    solo
                  >
                    <template v-slot:item="data">
                      <v-layout align-center>
                        <v-icon class="mr-2" size="18">mdi-briefcase</v-icon>
                        <span>
                          {{ data.item.name }} - {{
                            data.item.cpf_cnpj.length === 11 ?
                              formatString('xxx.xxx.xxx-xx', data.item.cpf_cnpj) : formatString('xx.xxx.xxx/xxxx-xx', data.item.cpf_cnpj)
                          }}

                        </span>
                      </v-layout>
                    </template>
                    <template v-slot:no-data>
                      <v-list>
                        <v-list-tile>
                          Entidade não encontrada
                        </v-list-tile>
                        <v-list-tile @click="newEntityDialog = true">
                          <v-layout class="blue--text" flat small>
                            <v-icon left color="blue">mdi-plus</v-icon>
                            <span>Adicionar nova entidade</span>
                          </v-layout>
                        </v-list-tile>
                      </v-list>
                    </template>
                  </v-autocomplete>
                </v-flex>
              </v-layout>

              <v-chip v-if="!isEmpty(formField.folderEntitySelected)">
                <v-avatar class="white">
                  <v-icon>mdi-account</v-icon>
                </v-avatar>
                {{ formField.folderEntitySelected.name }}
              </v-chip>
            </v-flex>

            <new-entity-dialog
              :show="newEntityDialog"
              @close="newEntityDialog = false"
              @entitySaved="onEntitySaved"
            />

            <div>
              <!-- v-if="!isEmpty(formField.folderTypeSelected && formField.folderEntitySelected)" -->
              <v-divider class="my-2"/>

              <v-layout row>
                <v-flex md4>
                  <v-subheader class="pa-0">
                    Processo Confidêncial
                    <v-menu
                      open-on-hover
                      top
                      offset-y
                    >
                      <v-icon class="ml-1" slot="activator">mdi-help-circle</v-icon>

                      <v-card>
                        <v-alert
                          class="ma-0"
                          value="true"
                          type="info"
                          outline
                        >
                          Processos confidenciais só podem ser abertas por quem possui, pelos colaboradores e clientes
                          interessados.
                        </v-alert>
                      </v-card>
                    </v-menu>
                  </v-subheader>
                  <v-switch
                    v-model="formField.folderConfidential"
                    :prepend-icon="formField.folderConfidential ? 'mdi-folder-lock' : 'mdi-folder-lock-open'"
                    :label="formField.folderConfidential ? 'Sim' : 'Não'"
                  />
                </v-flex>
              </v-layout>

              <v-divider class="my-2"/>

              <v-flex md6>
                <v-subheader class="pa-0">Protocolo Externo</v-subheader>
                <v-layout align-center>
                  <v-flex md6>
                    <v-text-field
                      v-model="formField.folderOutProtocolNumber"
                      :label="`Número ${externalProtocolName}`"
                    />
                  </v-flex>

                  <v-menu open-on-hover top offset-y>
                    <v-icon slot="activator">mdi-help-circle</v-icon>

                    <v-card>
                      <v-alert
                        class="ma-0"
                        value="true"
                        type="info"
                        outline
                      >
                        {{ externalProtocolName }} permite o controle de todas as atividades de Auditoria Interna e
                        Externa.
                      </v-alert>
                    </v-card>
                  </v-menu>
                </v-layout>
              </v-flex>
            </div>
          </v-layout>

          <v-card-actions>
            <v-btn
              flat
              large
              @click.stop="closeFolderForm"
            >
              Cancelar
            </v-btn>

            <v-spacer/>

            <v-tooltip top v-if="areFormFieldsInvalid">
              <v-btn
                color="success"
                large
                @click.stop="createFolder"
                :disabled="areFormFieldsInvalid"
                slot="activator"
              >
                Salvar
              </v-btn>
              <div>
                Preencha os dados dos campos marcados com
                <span>&nbsp;*</span>
              </div>
            </v-tooltip>
            <v-btn
              v-else
              color="success"
              large
              @click.stop="createFolder"
              :disabled="areFormFieldsInvalid"
            >
              Salvar
            </v-btn>
          </v-card-actions>
        </v-form>

        <v-layout
          v-if="isCreating"
          class="request-loading"
          align-center
          justify-center
        >
          <v-flex xs8>
            <v-progress-linear
              color="blue"
              :indeterminate="true"
            />
            <h3 class="headline text-xs-center">Salvando Processo</h3>
          </v-flex>
        </v-layout>
      </v-container>
    </v-navigation-drawer>
  </section>
</template>


<script>
import masks from '@/mixins/masks';
import bus from '@/utils/event-bus';
import {capitalize, isEmpty} from 'lodash';
import foldersService from '@/services/FoldersService';
import entityService from '@/services/EntityService';
import InterestedDialog from '@/components/folder/interested/edit/InterestedDialog';
import InterestedsAvatarList from '@/components/folder/interested/list/InterestedAvatarList';
import NewEntityDialog from '@/components/folder/new/NewEntityDialog';
import formatString from 'format-string-by-pattern';
import externalProtocolName from '@/utils/external-protocol-name';

const emptyFormFields = {
  folderTypeItems: [],
  folderTypeSelected: {},
  folderEntitySelected: {},
  folderConfidential: false,
  folderOutProtocolNumber: '',
  // folderInterested: [],
};

export default {
  name: 'NewFolder',
  components: {
    InterestedDialog,
    InterestedsAvatarList,
    NewEntityDialog,
  },
  data() {
    return {
      bus,
      entityQuery: '',
      entitiesFound: [],
      cpfMask: masks.cpf,
      cnpjMask: masks.cnpj,
      formField: {...emptyFormFields},
      isFetchingEntities: false,
      isCreating: false,
      isEmpty,
      isUserTyping: false,
      // interesteds: [],
      newEntityDialog: false,
      newFolderForm: false,
    };
  },
  mounted() {
    this.getFolderType();
    // bus.$on('setInteresteds', (val) => {
    //   this.interesteds = [...val];
    // });
  },
  computed: {
    areFormFieldsInvalid() {
      return isEmpty(this.formField.folderTypeSelected) ||
        isEmpty(this.formField.folderEntitySelected) ||
        isEmpty(this.formField.subject);
    },
    externalProtocolName() {
      return externalProtocolName();
    },
  },
  methods: {
    capitalize,
    formatString,
    getFolderType() {
      foldersService.getFolderTypes()
        .then((response) => {
          this.formField.folderTypeItems = response.data;
        });
    },
    getFolderEntity(query) {
      this.isFetchingEntities = true;
      entityService.getEntity(query)
        .then(({data}) => {
          this.entitiesFound = data;
        })
        .catch((error) => {
          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'error',
            message: error.message,
            messageIcon: 'mdi-alert-outline',
          });
        })
        .finally(() => {
          this.isFetchingEntities = false;
        });
    },
    resetFolderEntity() {
      this.formField.folderEntitySelected = {};
    },
    resetFormFolder() {
      this.formField = {...emptyFormFields};
      // this.interesteds = [];
      this.getFolderType();
    },
    closeFolderForm() {
      this.newFolderForm = false;
    },
    onEntitySaved({entity}) {
      this.entitiesFound.push(entity);
      this.formField.folderEntitySelected = entity;
      this.newEntityDialog = false;
    },
    createFolder() {
      const folder = {
        folder: {
          subject: this.formField.subject,
          folder_type_id: this.formField.folderTypeSelected.id,
          entity_id: this.formField.folderEntitySelected.id,
          confidential: this.formField.folderConfidential,
          number: this.formField.folderOutProtocolNumber,
          // interested_ids: this.interesteds.map(item => item.interested.id),
        },
      };
      this.isCreating = true;
      this.sendFolderCreationRequest(folder);
    },
    sendFolderCreationRequest(folder) {
      foldersService.createFolder(folder)
        .then((response) => {
          this.isCreating = false;
          console.log('Folder created successfully:', response.data);
          bus.$emit('folderCreated', {showDialog: true, folder: response.data.folder});
          this.closeFolderForm();
          this.resetFormFolder();
        })
        .catch((error) => {
          this.isCreating = false;
          this.$store.dispatch('toggleSnackbar', {
            show: true,
            color: 'error',
            message: error.message,
            messageIcon: 'mdi-alert-outline',
          });
        });
    },
  },
  watch: {
    entityQuery(val) {
      if (!val) return;
      clearTimeout(this.timeout);
      this.isUserTyping = true;
      this.timeout = setTimeout(() => {
        this.isUserTyping = false;
        this.getFolderEntity(val);
      }, 500);
    },
  },
};
</script>

<style lang="scss">
.new-folder {
  .request-loading {
    height: calc(100vh - 120px);
  }

  .new-button {
    z-index: 2;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/folder/new/FormNewFolder.vue